import { supabase } from '@/integrations/supabase/client';
import { clearAuthCaches } from './authTransitions';

/**
 * Perform sign-out: clear location, caches, then supabase signOut.
 */
export async function performSignOut(userId?: string): Promise<void> {
  if (userId) {
    await supabase
      .from('profiles')
      .update({
        live_location_active: false,
        live_latitude: null,
        live_longitude: null,
      } as Record<string, unknown>)
      .eq('user_id', userId);
  }

  await clearAuthCaches();

  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}
